import { render, staticRenderFns } from "./FolderWorkflowSendCosmoFormDialog.vue?vue&type=template&id=3efe4216&scoped=true"
import script from "./FolderWorkflowSendCosmoFormDialog.vue?vue&type=script&lang=js"
export * from "./FolderWorkflowSendCosmoFormDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderWorkflowSendCosmoFormDialog.vue?vue&type=style&index=0&id=3efe4216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe4216",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VSkeletonLoader,VSwitch})
